import React from "react";

import { StatusPill } from "../../shared/StudioControls";
import { CampaignSummary } from "../summary/CampaignSummary";

export const CampaignContextHeader = ({ campaign, stepNumber, stepCount, stepLabel, catalogue, cycleStart, isRefreshing, onBack, onRefresh }) => (
  <div className="cs-context-header">
    <div className="cs-context-header__bar">
      <button type="button" className="cs-back" onClick={onBack}>
        <span aria-hidden="true">‹</span>
        <span>Notifications</span>
      </button>
      <button type="button" className="cs-link-button" disabled={isRefreshing} onClick={onRefresh}>
        {isRefreshing ? "Refreshing…" : "Refresh"}
      </button>
    </div>
    <div className="cs-context-header__title">
      <span className={`cs-slot cs-slot--${campaign.slot}`} aria-label={`Notification set ${campaign.slot}`}>{campaign.slot}</span>
      <h1 className="cs-title">{campaign.payload.scenario.title}</h1>
      <StatusPill status={campaign.status} />
      <CampaignSummary campaign={campaign} catalogue={catalogue} cycleStart={cycleStart} />
    </div>
    <p className="cs-context-header__meta" aria-live="polite">
      <span className="cs-step-count">Section {stepNumber} of {stepCount} · {stepLabel}</span>
      <span className="cs-muted"> · Revision {campaign.payload.revision}</span>
    </p>
  </div>
);
